import React, { useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MLRPDF from "../components/MLRPDF/MLRPDF";

const TemplatePreview = (props) => {
  const navigate = useNavigate();
  const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  };

  const obj = {
    name: useQuery().get("name") || "",
    brand: useQuery().get("brand") || "",
    pdfURL: useQuery().get("pdfUrl"),
    mlrId: useQuery().get("mlrId"),
    id: useQuery().get("deckid"),
    campaign: useQuery().get("campaign"),
    country: useQuery().get("country"),
  };
  useEffect(() => {
    if (obj.name === "") {
      navigate("/");
    }
  }, []);
  return <>{useQuery().get("name") && <MLRPDF deckData={obj} />}</>;
};

export default TemplatePreview;
